import { render, staticRenderFns } from "./ChatChannelIcon.vue?vue&type=template&id=f689ad68&scoped=true"
import script from "./ChatChannelIcon.vue?vue&type=script&lang=ts"
export * from "./ChatChannelIcon.vue?vue&type=script&lang=ts"
import style0 from "./ChatChannelIcon.vue?vue&type=style&index=0&id=f689ad68&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f689ad68",
  null
  
)

export default component.exports